const s = (e) => Object.keys(e);
export {
  s as keysOf
};
